export default __webpack_public_path__ + "static/media/topbar-icon-mail.e058a11b.svg";